/**
 * Locale-aware formatting helpers. They pick the Malaysian English or Malay
 * locale from the active i18next language so dates and currency localise when
 * the user switches to Bahasa Malaysia. All times stay in Malaysia time.
 *
 * Pass `i18n.language` from `useTranslation()` as `lng`.
 */

function localeFor(lng: string | undefined): "en-MY" | "ms-MY" {
  return lng?.startsWith("ms") ? "ms-MY" : "en-MY";
}

export function formatDateTime(value: Date | string | number, lng?: string): string {
  const date = value instanceof Date ? value : new Date(value);
  return date.toLocaleString(localeFor(lng), {
    timeZone: "Asia/Kuala_Lumpur",
    dateStyle: "medium",
    timeStyle: "short"
  });
}

/** Date only (no time) — used where the time-of-day is noise, e.g. deadlines. */
export function formatDate(value: Date | string | number, lng?: string): string {
  const date = value instanceof Date ? value : new Date(value);
  return date.toLocaleDateString(localeFor(lng), {
    timeZone: "Asia/Kuala_Lumpur",
    dateStyle: "medium"
  });
}

export function formatCurrencyMYR(value: number, lng?: string): string {
  return new Intl.NumberFormat(localeFor(lng), {
    style: "currency",
    currency: "MYR",
    maximumFractionDigits: 0
  }).format(value);
}
